import * as React from "react";
// import dotaSpottoTheme from "./dotaspottotheme";
import { GoldButton } from "@ds-components/General/dotaspottotheme";
import { Box, ButtonGroup } from "@mui/material";
import { SpotifyTingState } from "@ds-components/Playlist/playlist";
import { getLocalStorage, setLocalStorage } from "@ds-services/helpers";
import * as Analytics from "@ds-services/analytics/analytics";
import { Playlist } from "@spotify/web-api-ts-sdk";
import { HeroLookup } from "@ds-types/dotes";
import { useAuthStore } from "@/store/authStore";
interface SpotifyActionsProps {
   hero: HeroLookup;
   selectedtracks: SpotifyTingState["tracksselected"];
   alltracks: SpotifyTingState["tracks"];
   getPlaylist: (playlist: Playlist) => void;
   searchterms: string[];
   isMobile: boolean;
}

const SpotifyActions: React.FC<SpotifyActionsProps> = ({ hero, selectedtracks, alltracks, getPlaylist, searchterms, isMobile }) => {

   const [createdPlaylistId, setCreatedPlaylistId] = React.useState<string | null>(null);
   const [alreadyCreated, setAlreadyCreated] = React.useState<boolean>(false);
   const { spotify, userProfile, showToast } = useAuthStore();

   React.useEffect(() => {
      if (hero?.localized_name) {
         setAlreadyCreated(hasAlreadyCreatedPlaylist(hero.localized_name));
      }
   }, [hero]);

   const hasAlreadyCreatedPlaylist = (heroId: string): boolean => {
      return !!getLocalStorage(`playlist_created_${heroId}`);
   };

   const markPlaylistAsCreated = (heroId: string) => {
      setLocalStorage(`playlist_created_${heroId}`, true);
   };

   const createPlaylist = React.useCallback(async (type: "all" | "selected") => {
      if (spotify && userProfile) {
         try {
            const dotaHeroName = hero?.displayName;
            const playlistName = `${dotaHeroName} Playlist By Dota Tunes`;
            const playlistDescription = `✨ Made in Dota Tunes. Tracks curated using these terms: ${searchterms.join(", ")}.`;
            const createDotaPlaylist: Playlist | undefined = await spotify.playlists.createPlaylist(userProfile.id, {
               name: playlistName,
               public: true,
               description: playlistDescription
            });
            const playlistId = createDotaPlaylist?.id;
            if (playlistId) {
               setCreatedPlaylistId(playlistId);
               markPlaylistAsCreated(hero.localized_name);
               setAlreadyCreated(true);
            }
            const allTrackUris = typeof alltracks !== "string" ? alltracks.map((track) => track.uri) : alltracks;
            const tracksToAdd = type === "all" ? allTrackUris : selectedtracks;

            //Track Playlist Creation
            if (hero && hero.displayName) {
               Analytics.trackCreatePlaylist(hero.displayName);
               if (type === "selected") {
                  Analytics.addSelectedTracksClicked(hero.displayName)
               } else if (type === "all") {
                  Analytics.addAllTracksClicked(hero.displayName)
               }
            }

            // Split tracksToAdd into chunks of 100 or less
            const trackChunks = Array.isArray(tracksToAdd) ? Array.from({ length: Math.ceil(tracksToAdd.length / 100) }, (_, i) =>
               tracksToAdd.slice(i * 100, (i + 1) * 100)
            ) : false;
            if (!trackChunks) return;
            for (const chunk of trackChunks) {
               await spotify.playlists.addItemsToPlaylist(
                  playlistId,
                  chunk
               )
            }
            getPlaylist(createDotaPlaylist);
            return createDotaPlaylist;
         } catch (error) {
            console.error("Error creating playlist or adding tracks:", error);
            showToast("Failed to create playlist. Please try again.", "error");
         }
      }
   }, [hero, selectedtracks, alltracks, getPlaylist, searchterms, showToast, spotify, userProfile]);


   return (
      <Box
         data-ismobile={isMobile ? '' : undefined}
         sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            "&[data-ismobile]": {
               boxSizing: "border-box",
               position: "fixed",
               bottom: 0,
               width: "100%",
               px: 1,
               pt: 1,
               pb: 2,
               left: 0,
               margin: 0,
               backgroundColor: "black"
            }
         }}
      >
         <ButtonGroup variant="contained" size="large">
            {(
               <GoldButton
                  onClick={() => createPlaylist("all")}
                  sx={{
                     flex: {
                        sx: 1,
                        md: "initial"
                     }
                  }}
                  disabled={!!createdPlaylistId || alreadyCreated}
               >
                  Add All Tracks
               </GoldButton>
            )}
            {selectedtracks && (
               <GoldButton
                  onClick={() => createPlaylist("selected")}
                  sx={{
                     flex: {
                        sx: 1,
                        md: "initial"
                     }
                  }}
               >
                  Add Selected Tracks
               </GoldButton>
            )}
         </ButtonGroup>
      </Box>
   );
};

export default SpotifyActions;
